// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1___bff9e7cae5c138f6ec2{/*!*/}.FocusedNav-cls2__c71bd10df77d30b1de88{position:relative;z-index:10;height:80px}.FocusedNav-cls2__c71bd10df77d30b1de88.FocusedNav-isMobileNav__ef8e5fd39c9ed5608fcd{height:56px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1___bff9e7cae5c138f6ec2",
	"cls2": "FocusedNav-cls2__c71bd10df77d30b1de88 FocusedNav-cls1___bff9e7cae5c138f6ec2",
	"isMobileNav": "FocusedNav-isMobileNav__ef8e5fd39c9ed5608fcd"
};
export default ___CSS_LOADER_EXPORT___;
